import { atom, useAtom, useSetAtom } from 'jotai';

/// SidebarMode
/// - uninitialized: Sidebar state is not yet known
/// - docked: Sidebar is pinned/docked to the side of the screen, unable to be collapsed
/// - expanded: Sidebar is manually expanded by the user, typically on mobile
/// - collapsed: Sidebar is not visible
export type SidebarMode = 'uninitialized' | 'docked' | 'expanded' | 'collapsed';

const sidebarModeAtom = atom<SidebarMode>('uninitialized');
const expandSidebarAtom = atom(null, (_get, set) => {
  set(sidebarModeAtom, 'expanded');
});
const collapseSidebarIfExpandedAtom = atom(null, (get, set) => {
  if (get(sidebarModeAtom) === 'expanded') {
    set(sidebarModeAtom, 'collapsed');
  }
});

export const useSidebarMode = () => useAtom(sidebarModeAtom);
export const useExpandSidebar = () => useSetAtom(expandSidebarAtom);
export const useCollapseSidebarIfExpanded = () => useSetAtom(collapseSidebarIfExpandedAtom);
